export default __webpack_public_path__ + "static/media/credit-card.a7d25e22.svg";